import { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../api/axiosInstance";
import Logo from "../../assets/logosnake.jpg";
import "./Resetform.css";
import { forgotPassword } from "../../api/adminAuthApi";

export default function Resetform() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // await api.post("/api/admin/auth/forgot-password", { email });
      const res = await forgotPassword({ email });
      if (res?.success) {
        toast.success("OTP sent to your email");
        navigate("/VerifyResetotp", { state: { email } });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="right-panel">
        <form className="login-card" onSubmit={handleSubmit}>
          <img className="logo-img" src={Logo} alt="logo" />
          <h2>Reset Password</h2>
          <p className="paragraph">
            Enter your registered email to receive OTP
          </p>

          <input
            type="email"
            placeholder="Enter Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button className="submit-btn" type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send OTP"}
          </button>
        </form>
      </div>
    </div>
  );
}
